import Constants from "expo-constants";

export const getLocalAPIBase = () => {
  const { expoGoConfig } = Constants;
  const uri = `http://${expoGoConfig?.debuggerHost?.split(":").shift()}:4000`;
  return uri;
};
